import React from "react";
import ReactModal from "react-modal";
import styles from "./styles.module.scss";
import { Loading } from "../../../../../../../components/Loading";
import { BrComerceApiService } from "../../../../../../../services/BrComerceApiService";
import Swal from "sweetalert2";
import { IoMdArrowRoundBack, IoIosClose } from "react-icons/io";
import { NoDelivery } from "./components/NotDelivery";
import { Delivery } from "./components/Delivery";
import { ownCollectNotFinishedOptions } from "./utils/packageDeliveryStatus";
import Title from "./components/Title";
import { LuPackageCheck, LuPackageX } from "react-icons/lu";
import { RouteOwnCollectStatusEnum } from "../../../../../../../enums/RouteOwnCollectStatusEnum";

const stylesModal22 = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(51, 51, 51, 0.75)",
    zIndex: 999
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    zIndex: 999,
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    overflow: "visible"
  }
};

const menuNames = {
  default: "default",
  delivery: "delivery",
  noDelivery: "no-delivery",
}


export const EditOwnCollectStatusModal = ({
  isOpen,
  handleCloseModal,
  ownCollect,
  refetch
}) => {
  const api = new BrComerceApiService();
  const deliveryData = ownCollect?.deliveriesData?.length
    ? ownCollect.deliveriesData[0]
    : undefined

  const needEvidence = !deliveryData

  const [loading, setLoading] = React.useState(false)
  const [openMenu, setOpenMenu] = React.useState(menuNames.default)

  const [routeOwnCollectOption, setRouteOwnCollectOption] = React.useState()
  const [receiverData, setReceiverData] = React.useState()
  const [routeOwnCollectError, setRouteOwnCollectError] = React.useState()

  const [evidenceError, setEvidenceError] = React.useState()
  const [evidenceImage, setEvidenceImage] = React.useState()

  async function handleSubmit() {
    let hasError = false
    const routeOwnCollectStatusValue = routeOwnCollectOption?.value
    const isNotDeliveryMenu = openMenu === menuNames.noDelivery

    if (!routeOwnCollectStatusValue && isNotDeliveryMenu) {
      hasError = true
      setRouteOwnCollectError("Campo obrigatório!")
    }

    if (needEvidence && !evidenceImage) {
      setEvidenceError("Evidência obrigatória!")
      hasError = true
    }

    if (hasError) {
      return
    }

    const routeOwnCollectStatusId = routeOwnCollectStatusValue

    try {
      let base64Image
      if (needEvidence && evidenceImage) {
        base64Image = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(evidenceImage);
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = error => reject(error);
        });
      }

      setLoading(true)
      await api.makeHttpRequest({
        method: "PUT",
        url: `/own-collect-route/status/${ownCollect.routeData.id_own_collect_route}`,
        data: {
          statusId: routeOwnCollectStatusId,
          addCollect: ownCollect?.status?.id === RouteOwnCollectStatusEnum.EM_ROTA_DE_COLETA.id,
          ...(!!receiverData && { receiverData }),
          ...(base64Image && { base64Image })
        }
      });
      Swal.fire({
        text: "Os status da coleta foram atualizados com sucesso.",
        title: "Sucesso!",
        icon: "success"
      });
    } catch (error) {
      const message = error?.response?.data?.message;

      Swal.fire({
        text: message ? message : "Falha ao atualizar status, tente novamente mais tarde.",
        title: message ? "Ocorreu um erro" : "Erro inesperado",
        icon: "error"
      });
    } finally {
      refetch()
      setLoading(false)
      handleCloseModal()
    }

  }

  function findOptionByValue(value, options) {
    return options.find(opt => opt?.value === value)
  }


  const onChangeRouteOwnCollectOption = (e) => {
    setRouteOwnCollectError()
    setRouteOwnCollectOption(e)
  }

  if (loading) return <Loading loading={loading} />
  return (
    <>
      <ReactModal
        isOpen={isOpen}
        shouldCloseOnOverlayClick
        dialogClassName="schedule-pickup-modal"
        onRequestClose={handleCloseModal}
        style={stylesModal22}
        showCancelButton={true}
      >
        {!!ownCollect && !loading
          ?
          (<div className={styles.container}>
            <div className={styles.closeButton}>
              <div>
                {(openMenu !== menuNames.default) && <IoMdArrowRoundBack onClick={() => setOpenMenu(menuNames.default)} />}
              </div>
              <button
                onClick={handleCloseModal}
              >
                <IoIosClose />
              </button>
            </div>

            {(openMenu === menuNames.delivery) && <Delivery
              handleSubmit={handleSubmit}
              handleBackButton={() => setOpenMenu(menuNames.default)}
              setReceiverData={setReceiverData}
              needEvidence={needEvidence}
              setEvidenceImage={setEvidenceImage}
              evidenceImage={evidenceImage}
              evidenceError={evidenceError}
              setEvidenceError={setEvidenceError}
            />}

            {(openMenu === menuNames.noDelivery) && <NoDelivery
              handleSubmit={handleSubmit}
              handleBackButton={() => setOpenMenu(menuNames.default)}
              onChange={onChangeRouteOwnCollectOption}
              defaultValue={routeOwnCollectOption}
              error={routeOwnCollectError}
              options={ownCollectNotFinishedOptions}
              needEvidence={needEvidence}
              setEvidenceImage={setEvidenceImage}
              evidenceImage={evidenceImage}
              evidenceError={evidenceError}
              setEvidenceError={setEvidenceError}
            />}

            {openMenu === menuNames.default && (<>
              <Title text={"Marcar coleta como:"} />
              <span>Altere o status da coleta entre realizada e não realizada.</span>
              <div className={styles.actionsContainer}>
                <button className={styles.deliveryButton} onClick={() => {
                  setRouteOwnCollectOption({ label: "Entrega realizada", value: 11 })
                  setOpenMenu(menuNames.delivery)
                }}>
                  Marcar como realizada <LuPackageCheck size={24} />
                </button>

                <button className={styles.noDeliveryButton} onClick={() => {
                  setReceiverData()
                  setRouteOwnCollectOption(findOptionByValue(ownCollect?.routeData?.status, ownCollectNotFinishedOptions))
                  setOpenMenu(menuNames.noDelivery)
                }}>
                  Marcar como não realizada <LuPackageX size={24} />
                </button>
              </div>
            </>)}

          </div>)
          :
          <div className={styles.container} style={{ maxWidth: "260px" }}>
            <h2> A coleta não está associado a nenhuma rota! </h2>
          </div>}
      </ReactModal >
    </>
  );
};
